import React, { useCallback, memo, useMemo } from 'react';

import { Grid } from 'e100-react-components';
import { MapInfoWindow } from 'entities/map';
import AutoNumber from './AutoNumber';
import { ObuCardsButton } from './ObuCardsButton';
import ObuNumber from './ObuNumber';
import Coordinates from './Coordinates';
import UpdateTime from './UpdateTime';

import { Map } from 'common/utils/Map/types/map';
import { Marker } from 'common/utils/MapMarker/types';

import { CarEBoxLocation, useCarOperations, useSelectedCarEBoxLocation } from 'entities/cars';
import { useStyles } from './styles';

export const CarEBoxLocationsInfoWindow = memo(({ map, markers, actionButtons }: CarEBoxLocationsInfoWindowProps) => {
  const selectedCarEBoxLocation = useSelectedCarEBoxLocation();
  const { resetSelectedCarEBoxLocation } = useCarOperations();
  const classes = useStyles();

  const closeInfoWindow = useCallback(() => {
    resetSelectedCarEBoxLocation();
  }, [resetSelectedCarEBoxLocation]);

  const coordinates: [number, number] = useMemo(() => (selectedCarEBoxLocation ? [
    selectedCarEBoxLocation.latitude,
    selectedCarEBoxLocation.longitude
  ]: [0, 0]), [selectedCarEBoxLocation]);

  if (!selectedCarEBoxLocation) {
    return null;
  }

  return (
    <MapInfoWindow
      coordinates={coordinates}
      map={map}
      markers={markers}
      showCloseIcon
      onClose={closeInfoWindow}
    >
      <Grid container spacing={0} classes={{ root: classes.container }}>
        <AutoNumber />
        <ObuCardsButton />
        <ObuNumber />
        <Coordinates />
        <UpdateTime />
        {actionButtons &&
          actionButtons({
            carEboxLocation: selectedCarEBoxLocation,
            closeInfoWindow,
          })}
      </Grid>
    </MapInfoWindow>
  );
});

interface CarEBoxLocationsInfoWindowProps {
  map: Map | null;
  markers: Marker | null;
  actionButtons?: ({
    carEboxLocation,
    closeInfoWindow,
  }: {
    carEboxLocation: CarEBoxLocation;
    closeInfoWindow: () => void;
  }) => React.ReactNode;
}
